import { Link } from 'react-router-dom'

export default function TopBar() {
  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.svg" alt="UniversalBench" className="h-8 w-8" />
          <span className="text-lg font-semibold text-slate-900">
            Universal<span className="font-bold">Bench</span>
          </span>
          <span className="ml-2 hidden sm:inline rounded-md bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
            STAGING
          </span>
        </Link>
        <nav className="text-sm text-slate-600">
          <a
            href="https://universalbench.dev"
            target="_blank"
            rel="noreferrer noopener"
            className="hover:text-slate-900 transition"
          >
            universalbench.dev
          </a>
        </nav>
      </div>
    </header>
  )
}
